// A type safe assignment from a partial record containing modifications to an exact record
export function exactMerge<R extends object, M extends Partial<R>>(
  record: R,
  modifications: M
): R {
  return { ...record, ...modifications } as R;
}
